import React from "react";
import Box from "@mui/material/Box";
import { Card, Paper } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import OutlinedInput from "@mui/material/OutlinedInput";
import { Typography } from "@mui/material";
import { Button } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Alert } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import InfoIcon from "@mui/icons-material/Info";
import GlobalLoader from "./CommonC/GlobalLoader";
import axios from "axios";

import { baseURL } from "../Config/config";
import Projectcolors from "../Utils/Colors";

import Arrow from "../images/arrow.png";
import model from "../images/model.png";
import neural from "../images/neural1.png";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import LinearProgress from "@mui/material/LinearProgress";
import PropTypes from "prop-types";

function LinearProgressWithLabel(props) {
  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Box sx={{ width: "100%", mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography
          variant="body2"
          sx={{ fontSize: 14 }}
          color="text.secondary"
        >{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
}

LinearProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number.isRequired,
};

function ANN(props) {
  const [test, setTest] = React.useState(null);
  const [layers, setLayers] = React.useState(null);
  const [epochs, setepochs] = React.useState(null);
  const [ann, setAnn] = React.useState([]);
  const [batch, setbatch] = React.useState(null);
  const [independent, setIndependent] = React.useState([]);
  const [dependent, setDependent] = React.useState([]);
  const [count, setCount] = React.useState([]);
  const [index, setIndex] = React.useState();
  const [unitsin, setunitsin] = React.useState([]);
  const [unitsde, setunitsde] = React.useState([]);
  const [trained, setTrained] = React.useState(false);
  const [modalTraining, setmodalTraining] = React.useState(false);
  const [getLoader, setGetLoader] = React.useState(false);
  const [catestatus, setcatestatus] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [openwarning, setopenwarning] = React.useState(false);
  const [openwarning2, setopenwarning2] = React.useState(false);
  const [opennumbers, setopennumbers] = React.useState(false);
  const [choosenalgo, setChoosenalgo] = React.useState([]);
  const [showinput, setshowinput] = React.useState([]);
  const [timeseries, settimeseries] = React.useState([]);
  const [message, setMessage] = React.useState("Model Training Failed !");
  const [progress, setProgress] = React.useState(0);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClosewarning = () => {
    setopenwarning(false);
  };

  const handleClosewarning2 = () => {
    setopenwarning(false);
  };

  const handleClosenumbers = () => {
    setopennumbers(false);
  };

  React.useEffect(() => {
    getBuildModel();
  }, []);

  const getBuildModel = () => {
    setGetLoader(true);
    const ProjectID = sessionStorage.getItem("projectID");
    fetch(
      `${baseURL}/getbuildmodel?projectID=${ProjectID}&loaded=${props.loaded}`
    )
      .then((res) => res.json())
      .then((data) => {
        setAnn(data.ann);
        //setcatestatus(data.catestatus);
        setIndependent(data.independent);
        setDependent(data.dependent);
        setunitsin(data.unitsin);
        setunitsde(data.unitsde);
        setCount(data.len_all);
        setshowinput(data.showinput);
        setChoosenalgo(data.hyperparameters);
        if (data.ann.length > 0) {
          setTest(data.ann[0]);
          setLayers(data.ann[1]);
          setepochs(data.ann[2]);
          setbatch(data.ann[3]);
        }
        setGetLoader(false);
        settimeseries(data.timeseries);
      })
      .catch((err) => {
        setGetLoader(false);
        console.log("err", err);
      });
  };

  const NextStep = () => {
    props.handleNextStep();
  };

  const handleSize = (e) => {
    setTest(e.target.value);
  };
  const handleLayers = (e) => {
    setLayers(e.target.value);
  };
  const handleepochs = (e) => {
    setepochs(e.target.value);
  };
  const handlebatch = (e) => {
    setbatch(e.target.value);
  };

  const aFunctions = [handleSize, handleLayers, handleepochs, handlebatch];
  const aLabels = [
    "Train Data %",
    "No of Layers",
    "No of Epochs",
    "Batch Size",
  ];

  const annData = [
    {
      name: "Train Data %",
      //label:"Size",
      placeholder: "80",
    },
    {
      name: "No of Layers",
      //label:"Layers",
      placeholder: "5",
    },
    {
      name: "No of Epochs",
      //label:"Epochs ",
      placeholder: "25",
    },
    {
      name: "Batch Size",
      //label:"Batches",
      placeholder: "50",
    },
  ];

  const tooltip = [
    "Data use to train ANN",
    "A neural network is made up of vertically stacked components called Layers.",
    "The number of passes of the entire training dataset the ANN has completed.",
    "The number of samples that will be passed through to the network at one time",
  ];

  const aPlaceholder = ["Size", "Layers", "Epochs", "Batches"];
  let timer;

  const trainmodel = () => {
    setProgress(0);
    setTrained(false);
    const ProjectID = sessionStorage.getItem("projectID");
    if (
      test === null ||
      layers === null ||
      epochs === null ||
      batch === null ||
      test === "" ||
      layers === "" ||
      epochs === "" ||
      batch === ""
    ) {
      setOpen(true);
    } else if (
      /[a-zA-Z]/.test(test) ||
      /[a-zA-Z]/.test(layers) ||
      /[a-zA-Z]/.test(epochs) ||
      /[a-zA-Z]/.test(batch)
    ) {
      setopennumbers(true);
    } else {
      setmodalTraining(true);

      const body = JSON.stringify({
        trainsize: test,
        layers: layers,
        epochs: epochs,
        batch: batch,
        ann: 1,
        ProjectID,
        choosenalgo,
        showinput,
        timeseries: 0,
      });

      const config = {
        onUploadProgress: (progressEvent) => {
          let seconds = 1500;
          timer = setInterval(() => {
            setProgress((prevProgress) =>
              prevProgress >= 99 ? 99 : prevProgress + 1
            );
          }, seconds);
        },
        headers: {
          "Content-Type": "application/json",
        },
      };
      axios
        .post(`${baseURL}/trainmodel`, body, config)
        .then((response) => {
          if (response.data.message === "error") {
            setMessage("Model Training Failed ! " + response.data.valueerror);
            setopenwarning(true);
            setmodalTraining(false);
          } else {
            setTrained(true);
            setmodalTraining(false);
            clearInterval(timer);
            setProgress(100);
          }
        })
        .catch((error) => {
          setMessage(
            "Model Training Failed ! Try to minimize Epochs or Maximize Batch Size."
          );
          setopenwarning(true);
          setmodalTraining(false);
        });
    }
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ color: "red", fontSize: "13px" }}
        >
          {"All Inputs require to train ANN"}
        </DialogTitle>
      </Dialog>

      <Dialog
        open={openwarning}
        onClose={handleClosewarning}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ color: "red", fontSize: "13px" }}
        >
          {message}
        </DialogTitle>
      </Dialog>

      <Dialog
        open={openwarning2}
        onClose={handleClosewarning2}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ color: "red", fontSize: "13px" }}
        >
          {"Model Training Failed!"}
        </DialogTitle>
      </Dialog>

      <Dialog
        open={opennumbers}
        onClose={handleClosenumbers}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ color: "red", fontSize: "13px" }}
        >
          {"Only Numerical Values accepted."}
        </DialogTitle>
      </Dialog>

      {catestatus || timeseries ? (
        <div>
            <Box
  component={Paper}
  elevation={0}
  sx={{
    height: "740px",
    p: 3,
    m: "2px 0",
    borderRadius: "24px",
    border: "2px solid #0078c9",
    background:
      "linear-gradient(to bottom,#ffffff,#fbfcff)",
    boxShadow:
      "0 8px 25px rgba(0,120,201,.08)",
  }}
>
            <div style={{ margin: "auto", width: "100%", textAlign: "center" }}>
              {timeseries ? (
               <Typography
                         sx={{
                           fontSize: 16,
                           color: Projectcolors.primary,
                           textAlign: "center",
                           mt: 25,
                           fontWeight: 600,
                         }}
                       >
                  Data Includes Time Series . Try Forecasting Algorithms.
                </Typography>
              ) : (
                <Typography
                          sx={{
                            fontSize: 16,
                            color: Projectcolors.primary,
                            textAlign: "center",
                            mt: 25,
                            fontWeight: 600,
                          }}
                        >
                  Make sure Step 2 (KPI) does not include categorical data to
                  train model with ANN.
                </Typography>
              )}
            </div>
          </Box>
        </div>
      ) : (
        <div>
          <Box
  component={Paper}
  elevation={0}
  sx={{
    height: "740px",
    p: 3,
    m: "2px 0",
    borderRadius: "24px",
    border: "2px solid #0078c9",
    background:
      "linear-gradient(to bottom,#ffffff,#fbfcff)",
    boxShadow:
      "0 8px 25px rgba(0,120,201,.08)",
  }}
>
  <Box
    sx={{
      display: "flex",
      gap: 2,
      mt: 4,
      alignItems: "stretch",
    }}
  >

    {/* LEFT PANEL */}

    <Paper
      elevation={5}
      sx={{
        flex:1.2,
        borderRadius:"22px",
        border:"1px solid #d9e9f7",
        position:"relative"
      }}
    >
      <Box
        sx={{
          position:"absolute",
          top:-15,
          left:20,
          px:2,
          py:.8,
          borderRadius:"20px",
          bgcolor:"#0078c9",
          color:"#fff",
          fontWeight:600,
          fontSize:16
        }}
      >
        Independent Variables
      </Box>

      <Box
        sx={{
          p:3,
          pt:6,
          height:420,
          overflowY:"auto"
        }}
      >
        {independent.map((item,i)=>(
          <Box sx={{mb:2}}>

            <Typography fontSize={12}>
              {item} ({unitsin[i]})
            </Typography>

            <img
              src={Arrow}
              alt=""
              style={{
                width:"100%",
                height:"28px"
              }}
            />

          </Box>
        ))}
      </Box>

    </Paper>


    {/* MODEL */}

    <Paper
      elevation={6}
      sx={{
        width:340,
        borderRadius:"24px",
        display:"flex",
        flexDirection:"column",
        justifyContent:"center",
        alignItems:"center",
        p:3
      }}
    >

      <Typography
        sx={{
          color:"#0078c9",
          fontWeight:700,
          fontSize:16,
          mb:4
        }}
      >
        SelexMB Training Model
      </Typography>

      <img
        src={model}
        alt=""
        style={{
          width:"80%",
          marginBottom:20
        }}
      />

      <img
        src={neural}
        alt=""
        style={{
          width:"80%"
        }}
      />

    </Paper>


    {/* DEPENDENT */}

    <Paper
      elevation={5}
      sx={{
        flex:1.2,
        borderRadius:"22px",
        border:"1px solid #d9e9f7",
        position:"relative"
      }}
    >
      <Box
        sx={{
          position:"absolute",
          top:-15,
          left:20,
          px:2,
          py:.8,
          borderRadius:"20px",
          bgcolor:"#0078c9",
          color:"#fff",
          fontWeight:600,
          fontSize:16
        }}
      >
        Dependent Variables
      </Box>

      <Box
        sx={{
          p:3,
          pt:6,
          height:420,
          overflowY:"auto"
        }}
      >

        {dependent.map((item,i)=>(

          <Box sx={{mb:2}}>

            <Typography fontSize={12}>
              {item} ({unitsde[i]})
            </Typography>

            <img
              src={Arrow}
              alt=""
              style={{
                width:"100%",
                height:"28px"
              }}
            />

          </Box>

        ))}

      </Box>

    </Paper>


    {/* ANN PARAMETERS */}

    <Paper
      elevation={5}
      sx={{
        width:360,
        borderRadius:"22px",
        border:"1px solid #d9e9f7",
        position:"relative"
      }}
    >
      <Box
        sx={{
          position:"absolute",
          top:-15,
          left:20,
          px:2,
          py:.8,
          borderRadius:"20px",
          bgcolor:"#0078c9",
          color:"#fff",
          fontWeight:600,
          fontSize:16
        }}
      >
        ANN Parameters
      </Box>

      <Box
        sx={{
          p:3,
          pt:6,
          height:420,
          overflowY:"auto"
        }}
      >

        {(ann.length ? ann : annData).map((item,i)=>(

          <Box
            sx={{
              display:"flex",
              justifyContent:"space-between",
              alignItems:"center",
              mb:2
            }}
          >

            <Typography
              sx={{
                width:"45%",
                fontSize:"12px"
              }}
            >
              {ann.length
                ? aLabels[i]
                : item.name}
            </Typography>

            <Box
              sx={{
                display:"flex",
                alignItems:"center"
              }}
            >

              <OutlinedInput
                size="small"
                onChange={aFunctions[i]}
                defaultValue={
                  ann.length
                    ? item
                    : ""
                }
                placeholder={
                  ann.length
                  ? ""
                  : item.placeholder
                }
                sx={{
                  width:"120px",
                  height:"36px",
                  fontSize:"12px",

                  borderRadius:"12px",

                  "& .MuiOutlinedInput-notchedOutline":
                  {
                    borderColor:"#0078c9"
                  },

                  "&:hover .MuiOutlinedInput-notchedOutline":
                  {
                    borderColor:"#9e0b22"
                  }
                }}
              />

              <Tooltip
                title={
                  <Typography fontSize={11}>
                    {tooltip[i]}
                  </Typography>
                }
              >
                <IconButton>

                  <InfoIcon
                    sx={{
                      fontSize:18
                    }}
                  />

                </IconButton>
              </Tooltip>

            </Box>

          </Box>

        ))}

      </Box>

    </Paper>

  </Box>


  {/* FOOTER */}

  <Box
    sx={{
      mt:4,
      display:"flex",
      justifyContent:"space-between",
      alignItems:"center"
    }}
  >

    <Box display="flex" gap={4}>
      <Typography fontSize={12}>
        Count: {count}
      </Typography>

      <Typography fontSize={12}>
        Independent: {independent.length}
      </Typography>

      <Typography fontSize={12}>
        Dependent: {dependent.length}
      </Typography>
    </Box>


    <Box>

      <Button
        onClick={trainmodel}
        variant="contained"
        sx={{
          width:"120px",
          height:"42px",
          borderRadius:"12px",
          mr:2,
          bgcolor:"#0078c9",
          fontSize: "12px",

          "&:hover":{
            bgcolor:"#9e0b22"
          }
        }}
      >
        Train
      </Button>

      <Button
        onClick={NextStep}
        variant="contained"
        sx={{
          minWidth:"50px",
          height:"42px",
          fontSize: "12px",
          borderRadius:"12px",
          bgcolor:"#0078c9",

          "&:hover":{
            bgcolor:"#9e0b22"
          }
        }}
      >
        <ChevronRightIcon/>
      </Button>
      </Box>


    </Box>
    <Box sx={{border:0}}>
              {trained ? (
                <Alert
                  sx={{
                    width: "20%",
                    fontSize: "12px",
                    color: Projectcolors.primary,
                    marginLeft: "0px",
                    marginTop: "9px",
                  }}
                  variant="outlined"
                  severity="success"
                >
                  Model Trained Successfully
                </Alert>
              ) : null}
            
            {modalTraining ? (
              <Box
                sx={{
                  width: "100%",
                  marginBottom: 0,
                  height: "20px",
                  marginTop: "10px",
                }}
              >
                <LinearProgressWithLabel
                  value={progress}
                  sx={{ height: "6px" }}
                />
              </Box>
            ) : null}
            {trained ? (
              <Box
                sx={{
                  width: "100%",
                  marginBottom: 0,
                  height: "20px",
                  marginTop: "0px",
                }}
              >
                <LinearProgressWithLabel
                  value={progress}
                  sx={{ height: "6px" }}
                />
              </Box>
            ) : null}
            </Box>

  </Box>

        </div>
      )}

      {getLoader ? <GlobalLoader /> : null}
    </div>
  );
}

export default ANN;
